import { ReactElement } from 'react';
import DocumentMeta from 'react-document-meta';
import translation from '../languages';

export type EdukiRoutesMeta = () => {
    description: string;
    title: string;
    auto?: {
        ograph: boolean;
    };
    image?: string;
    keywords?: string;
    meta?: {
        name: {
            robots: string;
        };
    };
};

const MetaWrapper = ({ component, meta }: { component: ReactElement; meta: EdukiRoutesMeta }) => (
    <DocumentMeta {...meta()}>{component}</DocumentMeta>
);

const translate = translation('meta');

export default translate(MetaWrapper);
